import { faFolderPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { Button } from "react-bootstrap";
import { AddUserGroupModal } from "./AddUserGroupModal";
import { UserGroup } from "../../../../models/User";

export interface AddUserGroupButtonProps {}

export function AddUserGroupButton(props: AddUserGroupButtonProps) {
    const [isAddGroupModalVisible, setAddGroupModalVisible] = useState(false);

    return (
        <>
            <Button variant="success" onClick={() => setAddGroupModalVisible(true)}>
                <FontAwesomeIcon icon={faFolderPlus} className="me-1" /> Create New User Group
            </Button>

            <AddUserGroupModal isVisible={isAddGroupModalVisible} setIsVisible={setAddGroupModalVisible} />
        </>
    );
}
